import { Icon } from "@circle-react-shared/Icon";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useCircleV4 } from "@circle-react/hooks/useCircleV4";
import { Banner } from "@circleco/compass/components/Banner";

import { t } from "@/i18n-js/instance";
import { Button } from "@/react/components/SettingsApp/CompassCompat/Button";
import { usePlanTrialOptInModal } from "@/react/components/SettingsApp/Plan/PlanTrialOptInModal";
import { useEventsTracker } from "@/react/hooks/analytics/useEventsTracker";
import { useMediaQuery } from "@/react/hooks/useMediaQuery";

import { usePlanTrialTopBanner } from "./usePlanTrialTopBanner";

export const PlanTrialTopBanner = () => {
  const { shouldShowBanner, handleDismiss } = usePlanTrialTopBanner();

  const { trackEvent } = useEventsTracker();
  const planTrialOptInModal = usePlanTrialOptInModal();
  const isMobile = useMediaQuery("(max-width: 500px)");
  const { isCircleV4 } = useCircleV4();

  if (!shouldShowBanner) {
    return null;
  }

  const handleUpgradeClick = () => {
    trackEvent("plan_trial_opt_in_banner.clicked", {
      is_plan_trial: true,
      location: "top_banner",
    });
    void planTrialOptInModal.show();
  };

  const handleDismissClick = () => {
    handleDismiss();
  };

  if (isCircleV4) {
    return (
      <Banner
        variant="info"
        title={t("plan_trial_top_banner.try_business")}
        actionProps={{
          variant: "gradient",
          children: t("plan_trial_top_banner.upgrade_free"),
          onClick: handleUpgradeClick,
        }}
        onDismiss={handleDismissClick}
      />
    );
  }

  return (
    <div className="border-b-primary bg-tertiary relative flex items-center justify-center border-b px-4 py-3">
      <div
        className={classNames("flex items-center", {
          "gap-2": isMobile,
          "gap-3": !isMobile,
        })}
      >
        <span className="text-default text-sm font-medium">
          {t("plan_trial_top_banner.try_business")}
        </span>
        {isMobile ? (
          <Icon
            type="24-arrow-right"
            size={24}
            className="text-dark"
            onClick={handleUpgradeClick}
          />
        ) : (
          <Button
            variant="marketing-gradient"
            small
            onClick={handleUpgradeClick}
          >
            {t("plan_trial_top_banner.upgrade_free")}
          </Button>
        )}
      </div>
      {!isMobile && (
        <button
          type="button"
          onClick={handleDismissClick}
          className="absolute right-4 top-1/2 -translate-y-1/2"
          aria-label={t("plan_trial_top_banner.dismiss")}
        >
          <Icon type="16-close" size={16} className="text-default" />
        </button>
      )}
    </div>
  );
};
